import './MenuElement.css'

export default function MenuElement({icon, thisMenuID, setMenuID, currentMenuID}) {
    const onClickMenu = e => {
        e.preventDefault()
        setMenuID(thisMenuID)
    }

    return <div className={currentMenuID === thisMenuID ? 'tda-MenuElement-Active' : 'tda-MenuElement'} onClick={onClickMenu}>
        {icon}
    </div>
}